(function () {
    "use strict";

    angular.module('iMatApp')
        .filter('moneyFormat', moneyFormatFilter);

    moneyFormatFilter.$inject = [];

    function moneyFormatFilter() {
        return function (amount, currency) {
            return formatPrice(amount, currency);
        };
    }
})();